import { EntitySelect } from "@dash/entity-list";
import { Button, CheckboxField } from "@dash/form";
import { Page, PageHeader, SectionHeader } from "@dash/page";
import { QuerySkeleton } from "@dash/skeleton";
import { GroupList } from "@megarax/iam-groups";
import React from "react";
import { MdCheck } from "react-icons/md";
import { useParams } from "react-router-dom-v5-compat";

import { AccountQueryDto, SaveAccountBody } from "@megaron/auth-contracts";
import { useClientManager } from "@megaron/react-clients";
import { Uuid } from "@megaron/uuid";

export const AccountPage: React.FunctionComponent = () => {
  const email = useParams<{ email: string }>().email!;

  const accountQuery = useClientManager("auth").accountQuery().useQuery({ email });

  const saveMutation = useClientManager("auth")
    .saveAccount()
    .useMutation({
      onSuccess: () => {
        accountQuery.refetch();
      },
    });

  return (
    <Page>
      <PageHeader>{email}</PageHeader>
      <QuerySkeleton query={accountQuery}>
        {(account) => (
          <>
            <AccountForm
              account={account}
              isLoading={saveMutation.isLoading}
              onSave={(body) => saveMutation.mutate({ email, ...body })}
            />
            <div>
              <SectionHeader>Role</SectionHeader>

              <div css={{ display: "flex", flexDirection: "column" }}>
                {account.roles.map((r) => (
                  <span key={r}>{r}</span>
                ))}
              </div>
            </div>
          </>
        )}
      </QuerySkeleton>
    </Page>
  );
};

const AccountForm: React.FunctionComponent<{
  account: AccountQueryDto;
  onSave: (account: SaveAccountBody) => void;
  isLoading: boolean;
}> = (props) => {
  const [groups, setGroups] = React.useState<{ id: Uuid; name: string }[]>(props.account.groups);
  const [isActive, setIsActive] = React.useState(props.account.isActive);

  return (
    <div css={{ maxWidth: "500px" }}>
      <CheckboxField value={isActive} onChange={setIsActive} label="Aktywny?" />
      <EntitySelect items={groups} label="Grupy" dialogPath="grupy" getName={(g) => g.name}>
        <GroupList isSelectable onSelect={setGroups} selected={groups} />
      </EntitySelect>

      <div css={{ marginTop: "1rem", display: "flex" }}>
        <Button
          icon={<MdCheck />}
          isLoading={props.isLoading}
          css={{ marginLeft: "auto" }}
          onClick={() =>
            props.onSave({
              groupIds: groups.map((g) => g.id),
              isActive,
            })
          }
        >
          Zapisz
        </Button>
      </div>
    </div>
  );
};
